import React from "react";

function HeaderSocial() {
  return (
    <div className="header_socials">
      <a
        href="https://www.linkedin.com/in/akande-tunji-708259174/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa-brands fa-linkedin-in"></i>
      </a>
      <a
        href="https://github.com/Tun95"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa-brands fa-github"></i>
      </a>
      <a href="https://dribble.com" target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-dribbble"></i>
      </a>
    </div>
  );
}

export default HeaderSocial;
